var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Main-Content",attrs:{"id":"CampaignEditDomains"}},[(_vm.loading)?_c('Page',{attrs:{"title":((_vm.$t('Editing')) + " ..."),"primaryAction":{
      label: _vm.$t('Add Domain'),
      disabled: true 
    },"secondaryActions":[{
      label: _vm.$t('Notes'),
      disabled: true
    }]}},[_c('LoadingLayout'),_c('LoadingLayout'),_c('LoadingLayout')],1):_vm._e(),(!_vm.loading)?_c('Page',{attrs:{"title":((_vm.$t('Editing')) + " '" + (_vm.campaign.name) + "'"),"primaryAction":{
      label: _vm.$t('Add Domain'),
      onAction: function () { _vm.addNewDomain() }
    },"secondaryActions":[{
      label: _vm.$t('Notes'),
      onAction: function () { _vm.eventHub.$emit('showCampaignNotes', _vm.campaign.id) }
    }]}},[_c('campaign-edit-header',{attrs:{"campaign":_vm.campaign}}),_c('Layout',[_c('LayoutSection',[_c('Card',{attrs:{"title":_vm.$t('Domains linked to this campaign')}},[_c('DataTable',{attrs:{"columns":[
              {
                key: 'domain',
                label: _vm.$t('Domain')
              }
            ],"row-actions":function (row) { return (_vm.getAction(row)); },"rows":_vm.filteredSitesLinked,"emptyText":_vm.$t('No domains')}})],1),_c('Card',{attrs:{"title":_vm.$t('Domains not linked')}},[_c('Filters',{attrs:{"query":_vm.filter},on:{"update:query":function($event){_vm.filter=$event}}}),_c('DataTable',{attrs:{"columns":[
              {
                key: 'domain',
                label: _vm.$t('Domain')
              }
            ],"row-actions":function (row) { return (_vm.getAction(row)); },"rows":_vm.filteredSitesNonLinked,"emptyText":_vm.$t('No domains')}})],1),_c('Card',{attrs:{"title":_vm.$t('Domains linked to other campaigns')}},[_c('DataTable',{attrs:{"columns":[
              {
                key: 'domain',
                label: _vm.$t('Domain')
              }
            ],"row-actions":function (row) { return (_vm.getAction(row)); },"rows":_vm.filteredSitesOther,"emptyText":_vm.$t('No domains')}})],1)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }